import NBL1_Player from "../Pages/NBL1_Player"
import NBL1_Staff from "../Pages/NBL1_Staff"
import NBL1_Official from "../Pages/NBL1_Official"
import NBL1_Media from "../Pages/NBL1_Media"

let Maintenance = false

// Load Models
const LoadModel = async (Passed) => {
    let result = {}
    if (Maintenance) {
        Passed.Type = 'Maintenance'
    }
    switch (Passed.Type) {
        // Player Form
        case 'Player':
            result = await NBL1_Player.LoadSchema(Passed)
            break;
        //Staff Form
        case 'Staff':
            result = await NBL1_Staff.LoadSchema(Passed)
            break;
        // Officials Form
        case 'Official':
            result = await NBL1_Official.LoadSchema(Passed)
            break;
        // Media Form
        case 'Media':
            result = await NBL1_Media.LoadSchema(Passed)
            break;
        // Maintenance Mode
        case 'Maintenance':
            result = {
                Portal: '2023 NBL1 Registration Portal',
                MainColor: "#0305a1",
                Logo: require(`../../assets/NBL1.png`),
                Title: `<h2>2023 NBL1 Registration Portal</h2>`,
                Description: ``,
                Suspended: Maintenance,
                steps: [
                    // Step 1
                    {
                        stepno: 1,
                        title: 'Registrations Suspended Due to Maintence',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: {
                            maintenance: {
                                type: 'img',
                                src: 'https://admin.ownurgoal.net.au/_lib/file/imgArticles/UnderMaintenance2.png',
                                height: "100%",
                                width: "100%",
                                //maxHeight: 1366,
                                //maxWidth: 768,
                                // contain: true,
                                col: 12,
                                class: "ma-2"
                            },
                        }
                    },
                ]
            }
            break;

        default:
            break;
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        let result = await LoadModel(Parameters)
        return result;
    },
}

